var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "lanaya-checkbox", on: { click: _vm.clickHandler } },
    [
      _c("span", {
        staticClass: "lanaya-checkbox__input",
        class: _vm.isChecked
      }),
      _vm._v(" "),
      _c("input", {
        staticClass: "lanaya-checkbox__original",
        attrs: { type: "checkbox" },
        domProps: { checked: _vm.value }
      }),
      _vm._v(" "),
      _c(
        "span",
        { staticClass: "lanaya-checkbox__label", class: _vm.isChecked },
        [_vm._t("default")],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-abe174ca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-abe174ca","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./packages/checkbox/Checkbox.vue
// module id = 54
// module chunks = 0